<script lang="ts">
    import { mediaQuery } from "../../store/stores";
    import Footer from "./Components/Footer.svelte";
    import Header from "./Components/Header.svelte";
    import Router from "./Router.svelte";
</script>

{#if $mediaQuery.mql.matches}
    <Header />

    <div class="container is-fluid">
        <Router>
            <slot />
        </Router>
    </div>
{:else}
    <slot>
        <Header />
        <div class="main">
            <Router>
                <slot />
            </Router>
        </div>
    </slot>
    <!-- <Footer /> -->
{/if}

<style>
    /* .main {
        overflow: auto;
        border-left: 1px solid lightgray;
        min-height: 100vh;
        background-color: rgb(244, 244, 244);
    } */

    .is-tablet {
        width: 100%;
        background-color: rgb(244, 244, 244);
    }

    .is-fluid {
        height: 100%;
        background-color: rgb(244, 244, 244);
    }

    .columns.zero-top-margin {
        margin-top: 0;
    }

    .main {
    }
</style>
